import { BannerSegmentEnum } from 'generated/graphql';

interface BannerLike {
    BannerSegment?: string | null;
    LibraryImageFile?: {
        DetailBannerStandard?: { Desktop?: string | null } | null;
    } | null;
}

/**
 * The professional's own hero for the enquiry gate's brand pane.
 *
 * Prefers a non-About banner, since About imagery is usually a team shot rather
 * than work. Falls back to any banner they do have: a professional with only an
 * About banner should still see themselves in the pane rather than the global
 * brand photo.
 */
export const getProfessionalHeroImage = (
    bannerImages: readonly BannerLike[] | null | undefined,
): string | undefined => {
    if (!bannerImages?.length) return undefined;
    const preferred =
        bannerImages.find(
            (b) => b.BannerSegment !== BannerSegmentEnum.Aboutus,
        ) ?? bannerImages[0];
    return (
        preferred?.LibraryImageFile?.DetailBannerStandard?.Desktop ?? undefined
    );
};
